// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"camera-off"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M22 18V6H17L15.5 3H8.5L8.03125 3.9375M2 20V6H6L20 20H2ZM12 16.5C9.79086 16.5 8 14.7092 8 12.5C8 11.2682 8.55686 10.1664 9.43258 9.43262L15.0674 15.0675C14.3337 15.9432 13.2319 16.5 12 16.5Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M2 2L21 21","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-camera-off')
export default class CameraOffIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'camera-off',
    }
  }
}
